<template>
    <div v-if="appData.terminatedContract" class="default-message" v-t="'message.error_contract_termination'">
    </div>
	<div v-else class="user-panel">
        <table v-if="appData.actionRequireTenantCount > 0" class="alertfield">
            <tr class="alertrecord" v-t="{ path: 'message.info_need_action_to_link_tenant', args: { actionRequireTenantCount: appData.actionRequireTenantCount } }" ></tr>
        </table>
		<table :class="{ 'with-alert' : (appData.actionRequireTenantCount > 0), 'no-alert' : (appData.actionRequireTenantCount == 0)}" cellpadding=0 cellspacing=0>
            <tr class="itemheader">
                <td width="30%" height="100%">
                    <div class="inner-panel">
                        <div class="scrollable">
                            <div class="treetitle" v-t="'message.item_setting'">
                            </div>
                            <el-tree v-if="showTree"
                                class="setting-tree"
                                :props="properties"
                                :load="loadNode"
                                lazy
                                ref="tree"
                                node-key="settingId"
                                default-expanded-keys="{clientRoot}"
                                highlight-current
                                @node-click="handleNodeClick"
                                @node-collapse="handleNodeCollapse"
                                :render-content="renderContent">
                            </el-tree>
						</div>
                    </div>
                </td>
                <td width="70%">
                    <div class="inner-panel">
                        <div class="scrollable">
                    	    <component
                	            v-bind:selectedNode="selectedNode"
                                v-bind:appData="appData"
        	                    :is="selectedChild"
        	                    :ref="selectedChild"
        	                    @setCurrentNode="setCurrentNode"
        	                    @reloadTree="reloadTree"
        	                    @reLoadTenantInfo="reLoadTenantInfo">
    	                    </component>
	                    </div>
                    </div>
                </td>
            </tr>
		</table>
	</div>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import InitialUserRightPanel from "@/components/InitialUserRightPanel.vue";
import LinkTenantSetting from "@/components/pc/setting/linktenant/LinkTenantSetting.vue";
import SamlSetting from "@/components/pc/setting/saml/SamlSetting.vue";
import PermitIpSetting from "@/components/pc/setting/permitip/PermitIpSetting.vue";
import AiAppSetting from "@/components/pc/setting/ai-app/AiAppSetting.vue";
import SttDictionarySetting from "@/components/pc/setting/sttextention/SttDictionarySetting.vue";
import SttP2PEngineSetting from "@/components/pc/setting/sttextention/SttP2PEngineSetting.vue";
import HelpLinkSetting from "@/components/pc/setting/helplink/HelpLinkSetting.vue";
import TwoPhaseMethodSetting from "@/components/pc/setting/twophasemethod/TwoPhaseMethodSetting.vue";
import E2EEncryptionSetting from "@/components/pc/setting/e2eencryption/E2EEncryptionSetting.vue";
import ClientSetting from "@/components/pc/setting/clientsetting/ClientSetting.vue";
import UserPublishInformation from "@/components/pc/setting/publishinformation/UserPublishInformation.vue";
import DisableP2PSaveVoiceSetting from "@/components/pc/setting/p2pSaveVoice/DisableP2PSaveVoiceSetting.vue";
import P2PAutoEndTimeSetting from "@/components/pc/setting/p2pSetting/P2PAutoEndTimeSetting.vue";
import DeviceManagementSetting from "@/components/pc/setting/devicemanagement/DeviceManagementSetting.vue";

export default {
    components: {
        InitialUserRightPanel,
        LinkTenantSetting,
        SamlSetting,
        PermitIpSetting,
        AiAppSetting,
        SttDictionarySetting,
        SttP2PEngineSetting,
        TwoPhaseMethodSetting,
        E2EEncryptionSetting,
        HelpLinkSetting,
        ClientSetting,
        UserPublishInformation,
        DisableP2PSaveVoiceSetting,
        P2PAutoEndTimeSetting,
        DeviceManagementSetting
    },

    props: ['appData'],

    data() {
        return {
            showTree: true,
            clientSettingNode: [],
            selectedNode: null,
            templateCount: 0,
            enableAddClientSetting: false,
            loadCompleted: false,
            needToReloadTree: false,
            properties: {
                label: 'label',
                isLeaf: 'isLeaf'
            },
        };
    },
    methods: {
        loadNode(node, resolve) {
            var data = [];
            if (node.parent == null) {
                /* hide server setting.*/
                let settingName = commonUtil.getMessageText(this.$i18n,"item_inter_company_comm");
                let serverSetting = {
                                        settingId: "linktenant",
                                        settingName: settingName,
                                        label: settingName,
                                        type: constants.SETTING_INTER_COMPANY,
                                        isLeaf: true
                                    };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n,"item_saml_setting");
                serverSetting = {
                                        settingId: "saml",
                                        settingName: settingName,
                                        label: settingName,
                                        type: constants.SETTING_SAML,
                                        isLeaf: true
                                    };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n,"item_permit_ip_setting");
                serverSetting = {
                                        settingId: "permitip",
                                        settingName: settingName,
                                        label: settingName,
                                        type: constants.SETTING_PERMIT_IP,
                                        isLeaf: true
                                    };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n,"item_ai_setting");
                serverSetting = {
                                        settingId: "aiappsetting",
                                        settingName: settingName,
                                        label: settingName,
                                        type: constants.SETTING_AI_APP,
                                        isLeaf: true
                                    };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n,"item_stt_extension_setting");
                serverSetting = {
                                        settingId: "stt_extension_setting",
                                        label: settingName,
                                        type: constants.SETTING_STT_EXTENSION_ROOT,
                                        isLeaf: false,
                                    };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n, "item_two_phase_method_setting");
                serverSetting = {
                                        settingId: "twophasemethod",
                                        settingName: settingName,
                                        label: settingName,
                                        type: constants.SETTING_TWO_PHASE_METHOD,
                                        isLeaf: true
                                    };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n,"item_device_management_setting");
                serverSetting = {
                                        settingId: "deviceManagementSetting",
                                        label: settingName,
                                        type: constants.SETTING_DEVICE_MANAGEMENT,
                                        isLeaf: true
                                    };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n,"item_e2e_encryption");
                serverSetting = {
                                        settingId: "e2eencryptionsetting",
                                        label: settingName,
                                        type: constants.SETTING_E2E_ENCRYPTION,
                                        isLeaf: true
                                    };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n,"item_peer_to_peer_setting");
                serverSetting = {
                                        settingId: "peer_to_peer_setting",
                                        settingName: settingName,
                                        label: settingName,
                                        type: constants.SETTING_P2P,
                                        isLeaf: false
                                    };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n,"item_help_link_setting");
                serverSetting = {
                                        settingId: "helpLinkSetting",
                                        label: settingName,
                                        type: constants.SETTING_HELP_LINK,
                                        isLeaf: true
                                    };
                data.push(serverSetting);

                let self = this;
                this.clientSettingNode = [];
                server.post('/getenforceclientsettinglist')
                    .then((res) => {
                        let settingName = commonUtil.getMessageText(self.$i18n,"item_enforce_client_setting");
                        switch(res.data.status) {
                            case 0:
                                var isLeaf = false;
                                this.templateCount = 0;
                                if (res.data.template.length == 0) {
                                    isLeaf = true;
                                }
                                let clientSettingRoot = {
                                                        settingId: "clientRoot",
                                                        settingName: settingName,
                                                        label: settingName,
                                                        type: constants.SETTING_CLIENT_MANAGE_ROOT,
                                                        isLeaf: isLeaf
                                                    };
                                data.push(clientSettingRoot);

                                for (let i = 0; i < res.data.template.length; i++) {
                                    this.clientSettingNode.push({
                                        settingId: res.data.template[i].templateId,
                                        settingName: res.data.template[i].templateName,
                                        label: res.data.template[i].templateName,
                                        type: constants.SETTING_CLIENT_MANAGE_NODE,
                                        isLeaf: true
                                    })
                                    this.templateCount++;
                                }
                                this.clientSettingNode.sort(function(e1, e2) {
                                    if (e1.type < e2.type) return -1;
                                    else if (e1.type > e2.type) return 1;
                                    else {
                                        let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                                        if (comparisonResult < 0) return -1;
                                        else if (comparisonResult > 0) return 1;
                                    }
                                    return 0;
                                });
                                break;
                            case -15:           // enforce client setting license not found.
                                clientSettingRoot = {
                                                        settingId: "clientRoot",
                                                        settingName: settingName,
                                                        label: settingName,
                                                        type: constants.SETTING_CLIENT_MANAGE_ROOT,
                                                        isLeaf: true
                                                    };
                                data.push(clientSettingRoot);
                                break;
                            default:
                                node.loading = false;
                                node.isLeaf = true;
                                node.data.isLeaf = true;
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","loadNode").replace("{code}",res.data.status));
                                break;
                        }

                        let publishInformationsName = commonUtil.getMessageText(this.$i18n,"title_user_publish_information1");
                        let userInformationRoot = {
                                                settingId: "userInformation",
                                                settingName: publishInformationsName,
                                                label: publishInformationsName,
                                                type: constants.SETTING_USER_PUBLISH_INFORMATION_ROOT,
                                                isLeaf: false
                                            };
                        data.push(userInformationRoot);

                        resolve(data);
                        this.loadCompleted = true;
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "loadNode", error);
                    });
            } else {
                switch(node.data.settingId) {
                    case "stt_extension_setting":
                        resolve(commonUtil.getSttExtensionTreeData(this.$i18n));
                        break;
                    case "clientRoot":
                        resolve(this.clientSettingNode);
                        break;
                    case "userInformation":
                        resolve(commonUtil.getUserPublishInformationTreeData(this.$i18n));
                        break;
                    case "peer_to_peer_setting":
                        resolve(commonUtil.getSettingP2PTreeData(this.$i18n));
                        break;
                }
            }
        },
        handleNodeClick(data, node, elNode) {
            this.selectedNode = node;
            switch(data.type) {
                case constants.SETTING_INTER_COMPANY:
                case constants.SETTING_SAML:
                    this.enableAddClientSetting = false;
                    break;
                case constants.SETTING_CLIENT_MANAGE_ROOT:
                    if ((this.appData.enableConfigTrial || this.appData.enableConfigOption) & (this.templateCount==0)) {
                        this.enableAddClientSetting = true;
                    } else {
                        this.enableAddClientSetting = false;
                    }
                    break;
                case constants.SETTING_CLIENT_MANAGE_NODE:
                    this.enableAddClientSetting = false;
                    break;
            }
        },
        handleNodeCollapse(data, node, elNode) {
            node.expand();
        },
        addClientSetting() {
            this.$refs.ClientSetting.addSetting(this.$refs.tree.root.childNodes[1]);
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = "";
            let height = "20px";

            switch (data.type) {
                case constants.SETTING_INTER_COMPANY:             // server setting
                case constants.SETTING_SAML:
                    objectIcon = require("../../../assets/icon_server_setting.svg");
                    break;
                case constants.SETTING_CLIENT_MANAGE_ROOT:        // client setting's root
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break;
                case constants.SETTING_CLIENT_MANAGE_NODE:        // client setting
                    objectIcon = require("../../../assets/square_green.svg");
                    height = "6px";
                    break;
                case constants.SETTING_PERMIT_IP:       // permit_ip_setting
                    objectIcon = require("../../../assets/icon_server_setting.svg");
                    break;
                case constants.SETTING_USER_PUBLISH_INFORMATION_ROOT:     // publish information root
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break;
                case constants.SETTING_USER_PUBLISH_INFORMATION_NODE:     // publish information node
                    objectIcon = require("../../../assets/square_green.svg");
                    height = "6px";
                    break;
                case constants.SETTING_AI_APP:
                    objectIcon = require("../../../assets/icon_server_setting.svg");
                    break;
                case constants.SETTING_P2P:
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break;
                case constants.SETTING_DISABLE_P2P_SAVE:
                case constants.SETTING_STT_EXTENSION_P2P_ENGINE:
                case constants.SETTING_P2P_AUTO_END_TIME:
                    objectIcon = require("../../../assets/icon_client_setting.svg");
                    break;
                case constants.SETTING_TWO_PHASE_METHOD:
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break;
                case constants.SETTING_E2E_ENCRYPTION:
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break;
                case constants.SETTING_HELP_LINK:
                case constants.SETTING_DEVICE_MANAGEMENT:
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break
                case constants.SETTING_STT_EXTENSION_ROOT:
                case constants.SETTING_STT_EXTENSION_DICTIONARY:
                    objectIcon = require("../../../assets/icon_server_setting.svg");
                    break;
            }

            return h("span", [h("img", { attrs: { src: objectIcon ,height: height, style: "vertical-align: middle" } }), h("span", node.label)]);
        },
        reloadTree() {
            this.showTree = false;
            this.$nextTick(() => {
                 this.showTree = true
            })
        },
        setCurrentNode(settingId) {
            this.$refs.tree.setCurrentKey(settingId);
            this.selectedNode = this.$refs.tree.getNode(settingId);
        },
        reLoadTenantInfo() {
            this.$emit('loadTenantInfo');
        }
    },
    created: function() {
    },
    mounted: function() {
        this.selectedNode = this.$refs.tree.getNode(0);
    },
    computed: {
        selectedChild: function() {
            if (this.selectedNode != null) {
                switch (this.selectedNode.data.type) {
                    case constants.SETTING_INTER_COMPANY:
                        return "LinkTenantSetting";
                    case constants.SETTING_CLIENT_MANAGE_ROOT:
                    case constants.SETTING_CLIENT_MANAGE_NODE:
                        return "ClientSetting";
                    case constants.SETTING_PERMIT_IP:
                        return "PermitIpSetting";
                    case constants.SETTING_SAML:
                        return "SamlSetting";
                    case constants.SETTING_USER_PUBLISH_INFORMATION_ROOT:
                    case constants.SETTING_USER_PUBLISH_INFORMATION_NODE:
                        return "UserPublishInformation";
                    case constants.SETTING_AI_APP:
                        return "AiAppSetting";
                    case constants.SETTING_DISABLE_P2P_SAVE:
                        return "DisableP2PSaveVoiceSetting";
                    case constants.SETTING_TWO_PHASE_METHOD:
                        return "TwoPhaseMethodSetting";
                    case constants.SETTING_E2E_ENCRYPTION:
                        return "E2EEncryptionSetting";
                    case constants.SETTING_HELP_LINK:
                        return "HelpLinkSetting";
                    case constants.SETTING_STT_EXTENSION_DICTIONARY:
                        return "SttDictionarySetting";
                    case constants.SETTING_STT_EXTENSION_P2P_ENGINE:
                        return "SttP2PEngineSetting";
                    case constants.SETTING_P2P_AUTO_END_TIME:
                        return "P2PAutoEndTimeSetting"
                    case constants.SETTING_DEVICE_MANAGEMENT:
                        return "DeviceManagementSetting";
                }
            }
            this.appData.selectedMenu = 'setting';
            return "InitialUserRightPanel";
        },
    },
    watch: {
        '$i18n.locale' () {
            if (this.loadCompleted) {
                this.reloadTree();
            } else {
                // Part of data is not displayed by selected language when selected locale has changed during loading data of tree.
                // check needToReloadTree at loadCompleted , and reloadTree to display all data by selected language.
                this.needToReloadTree = true;
            }
        },
        'loadCompleted' () {
            if (this.loadCompleted) {
                if (this.needToReloadTree) {
                    this.reloadTree();
                    this.needToReloadTree = false;
                }
            }
        },
        '$route' (to, from) {
            if (to.name == "Setting") {
                this.$refs.tree.setCurrentKey(null);
                this.selectedNode = null;
            }
        }
    }
}
</script>

<style scoped>
table {
    border-collapse: collapse;
}
table.no-alert {
    height:100%;
    width:100%;
    cellpadding:0;
    cellspacing:0;
}
table.with-alert {
    height:calc(100% - 53px);
    width:100%;
    cellpadding:0;
    cellspacing:0;
}

.treetitle {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
}

.user-panel {
	height: 100%;
	background-color: #ffffff;
}

.inner-panel {
	position:relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
	background-color: #ffffff;
}

.scrollable {
	overflow: auto;
	position: absolute;
	top: 0;
	right:0;
	bottom: 0;
	left: 0;
    border-top: solid;
    border-color: #eee;
    border-width: 1px;
}

.command-area {
    background-color: #ecf1fa;
    width: 100%;
    display: block;
    text-align: left;
    padding-left: 20px;
    height: 56px;
    vertical-align: bottom;
}
.command-area-left {
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: middle;
    float: left;
}
.command-area-right {
    padding-right: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align : right;
    vertical-align: middle;
}
.setting-table {
    padding-top: 20px;
    padding-left: 20px;
    width: 480px;
}
.optionItem {
    width: 500px;
}

.setting-tree.el-tree >>> .el-tree-node {
    min-width: 300px;;
}
.setting-tree.el-tree {
    overflow: auto;
}
.setting-tree.el-tree {
    width: 100%;
    height: calc(100vh - 120px);
}

</style>
